import axios from '.';

export default {
  sendTipToPerformer,
};

async function sendTipToPerformer(data) {
  const response = await axios.post('/api/face2face/send-tip-to-performer', data);

  return response;
}
